export const SMS_DESTINATION_NUMBER = 9217;
export const SMS_BUNDLE_DESTINATION_NUMBER = 999;
export const SMS_BUNDLE_BASE_PLAN_ID = ['ASC', 'ADC'];
